<script>
    export let name = false;
    export let symbol = true;
    export let product = "evalueaid";
    export let type = "svg";

    let urlPath = {
        evalueaid: "/",
        participaid: "/participaid",
        valueaid: "/valueaid",
        teamaid: "/teamaid"
    }[type];
</script>

<a href="{urlPath}" class="logo-wrapper">
    {#if symbol}
        <img class="logo-symbol" src="/logo/{product}-symbol.{type}" alt="{type} logo">
    {/if}
    {#if name}
        <img class="logo" src="/logo/{product}.{type}" alt="{type} logo">
    {/if}
</a>

<style>
    img {
        z-index: 1;
    }
</style>